import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { sm },
} = constants.breakpoints;
const { ui } = constants.colors;
const { fontFamily } = typographyStyles;

const neutral400 = ui.neutral[400];
const neutral700 = ui.neutral[700];
const white = ui.white[700];

export const buttonCss = (isSelected) => {
  return {
    fontSize: "14px",
    lineHeight: "114%",
    padding: "8px",
    color: isSelected ? white : neutral400,
    ...(isSelected && { backgroundColor: neutral700 }),
    borderRadius: "40px",
    fontFamily: fontFamily.circular,
    fontWeight: "700",
    whiteSpace: "nowrap",

    [mq.downTo(sm)]: {
      fontSize: "16px",
      lineHeight: "150%",
      fontFamily: fontFamily.circular,
      padding: "6px 24px",
    },

    "&:hover": {
      color: neutral700,
    },
  };
};
